import styled from 'styled-components';

const Container = styled.div`
  margin: 0 auto;
  width: 100%;
  max-width: ${({ wide }) => (wide ? '80' : '43.75')}rem;
  padding: 0 1rem;
`;

export default Container;
